/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PurchasesInputs */

const en_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchases`)
};

const es_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compras`)
};

const fr_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achats`)
};

const de_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufe`)
};

const ja_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入履歴`)
};

const zh_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的购买`)
};

const ar_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشتريات`)
};

const id_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian`)
};

const it_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisti`)
};

const ru_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покупки`)
};

const pt_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compras`)
};

const ko_purchases = /** @type {(inputs: PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 내역`)
};

/**
* | output |
* | --- |
* | "Purchases" |
*
* @param {PurchasesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const purchases = /** @type {((inputs?: PurchasesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PurchasesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchases(inputs)
	if (locale === "es") return es_purchases(inputs)
	if (locale === "fr") return fr_purchases(inputs)
	if (locale === "de") return de_purchases(inputs)
	if (locale === "ja") return ja_purchases(inputs)
	if (locale === "zh") return zh_purchases(inputs)
	if (locale === "ar") return ar_purchases(inputs)
	if (locale === "id") return id_purchases(inputs)
	if (locale === "it") return it_purchases(inputs)
	if (locale === "ru") return ru_purchases(inputs)
	if (locale === "pt") return pt_purchases(inputs)
	return ko_purchases(inputs)
});